"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DefaultDogRadio = exports.DefaultCatRadio = exports.DefaultAnimalRadioInputs = exports.DefaultAboutPet = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var DefaultDogRadio = exports.DefaultDogRadio = {
  icon: {
    checked: 'dog-filled',
    unchecked: 'dog-outline'
  },
  label: 'Dog',
  showIcon: true,
  value: 'Dog'
};
var DefaultCatRadio = exports.DefaultCatRadio = {
  icon: {
    checked: 'cat-filled',
    unchecked: 'cat-outline'
  },
  label: 'Cat',
  showIcon: true,
  value: 'Cat'
};
var DefaultAnimalRadioInputs = exports.DefaultAnimalRadioInputs = [_objectSpread({}, DefaultDogRadio), _objectSpread({}, DefaultCatRadio)];
var DefaultAboutPet = exports.DefaultAboutPet = {
  heading: function heading(_ref) {
    var petName = _ref.petName;
    return "About ".concat(petName || 'your pet');
  },
  accordionBehaviour: true,
  addPetButton: {
    label: 'Insure another pet'
  },
  petSpeciesRadios: {
    groupLabel: function groupLabel() {
      return 'I have a...';
    },
    groupLabelTooltip: null,
    radioInputs: DefaultAnimalRadioInputs
  },
  petNameInput: {
    label: function label() {
      return 'My pet\'s name is...';
    },
    labelTooltip: /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, "If you would like to get a quote for more than one pet, you can apply to insure another pet using the \"Insure another pet\" button below."),
    placeholder: 'Enter name',
    validation: {
      required: 'Please enter your pet\'s name.'
    }
  },
  petBreedInput: {
    label: function label(petName) {
      return "".concat(petName || 'My pet', "'s breed is...");
    },
    labelTooltip: 'If you cannot find your pet\'s dominant breed or cross-breed, please enter small, medium or large unknown breed based on expected size when fully grown. We factor in each breed\'s typical claim history to personalise your insurance.',
    placeholder: 'Start typing breed',
    validation: {
      required: 'Please enter your pet\'s breed.'
    }
  },
  petBirthdate: {
    label: function label(petName) {
      return "".concat(petName || 'My pet', " was born on...");
    },
    labelTooltip: null,
    placeholder: 'dd/mm/yyyy',
    validation: {
      required: 'Please enter your pet\'s date of birth.',
      min: 'We\'re sorry, we can\'t start cover for your pet. There is a maximum entry age for new policies.',
      max: 'We can\'t start cover for your pet before the age of 8 weeks.'
    }
  },
  petGenderRadios: {
    groupLabel: function groupLabel(petName) {
      return "".concat(petName || 'My pet', " is a...");
    },
    radioInputs: [{
      label: 'Male',
      value: 'Male'
    }, {
      label: 'Female',
      value: 'Female'
    }]
  },
  petDesexedRadios: {
    groupLabel: function groupLabel(petName) {
      return "".concat(petName || 'Your pet', " is desexed...");
    },
    radioInputs: [{
      label: 'Yes',
      value: 1
    }, {
      label: 'No',
      value: 2
    }, {
      label: 'Unsure',
      value: 0
    }]
  },
  petDesexedDefault: 0,
  restrictedBreeds: {
    dog: [],
    cat: []
  }
};